import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import QRCode from "react-qr-code";

const AssetQrCode = ({qrDialogOpen, setQrDialogOpen, selectedAsset}) => {
  return (
    <Dialog open={qrDialogOpen} onClose={() => setQrDialogOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Asset QR Code</DialogTitle>
      <DialogContent dividers>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          py={1}>
          <QRCode
            value={
              selectedAsset?.BarCode ??
              selectedAsset?.BarCode?.toString() ??
              selectedAsset?.BarCode?.toString() ??
              ""
            }
            size={180}
          />
          <Typography variant="body2" color="text.secondary">
            {selectedAsset?.BarCode ??
              selectedAsset?.BarCode?.toString() ??
              selectedAsset?.BarCode?.toString() ??
              ""}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setQrDialogOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetQrCode;